SingleProduct.directive( 'removeLoader', [ function() {
	return {
		restrict: 'A',
		link: function (scope, element) {
			element.removeClass('loading')
		}
	}
}])